import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsArticlesRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-articles',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
	exact: true,
};
